<template>
  <div>
    <ui-modal
      ref="modal"
      :title="`Actualizar Late Arrival: ${id_booking}`"
      size="small"
      @close="actionSetVisibleModalEditarLateArrival(false)"
    >
      <div>
        <div class="d-flex flex-column mt-2">
          <Loading v-if="load" />

          <div v-else>
            <div>
              <data-table
                
                :headers="headers"
                :data="contenedoresItinerario"
                :acciones="accionesAux"
                :formulario="true"
                :idtabla="'lista_late_arrivals_Detalle'"
                :seleccionar="obtenerFilaSeleccionada"
                :numerador="true"
              />

            </div>
            <div style="text-align: center">
              <button
                style="margin-bottom: 0px !important"
                class="btn btn-outline-warning"
                title="Actualizar Late Arrival"
                horizontal
                id="buttonRef"
                @click="guardarLateArrival()"
              >
              Actualizar
              </button>
            </div>
          </div>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapState } from "vuex";

// Keen UI
import UiModal from "keen-ui/lib/UiModal";
import DataTable from "../../../../common/DataTable";

// Constantes
import {
     actualizarLateArrivalsPorBookingItinerario,
 } from "../../../../../constants/lineas";
import Loading from "../../../../common/loading.vue";
export default {
  props: ["data", "contenedoresItinerario", "accionesAux", "cargarLateArrivalsPorItinerario","load"],
  data() {
    return {
      headers: [
        "Número Contenedor",
        "Acción"
      ],
      // cantContenedoresModel: "",
      nroContenedorModel: "",
      id_booking: "",
      acciones: [],
      realdata: this.contenedoresItinerario,
      booking_itinerary_id: 0,
      dataAux: this.data,
      type: [{ key: 0, type: "textbox" }],
    };
  },

  computed: {
    ...mapState("lineas", ["visibleModalEditarLateArrival"]),
  },
  components: {
    UiModal,
    DataTable,
    Loading
},
  methods: {
    ...mapActions("lineas", [
      "actionSetVisibleModalEditarLateArrival",
      "actionSetDataBookingsLateArrivals",
    ]),

    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    estadoButton( text , estado = true ) {
      let buttonRef = document.querySelector('#buttonRef') ;
      buttonRef.innerHTML = text ;
      buttonRef.disabled = estado ;
    },
    async guardarLateArrival(){

      this.estadoButton("Actualizando..."  ) ;

      const form = {
        booking_itinerary_id : this.booking_itinerary_id,
        late_arrivals : this.contenedoresItinerario.map( ci => {
          return {
            id : ci.data_complementaria.id ,
            container_number : ci.data[0].trim()
          }
        })
      }
      let valid = true ;
      for (const la of form.late_arrivals ) {
        
        if( la.container_number == "" ) {
          valid = false ;
          this.estadoButton("Actualizar" , false  ) ;
          return ;
        }
      }

      if( !valid ){
        this.estadoButton("Actualizar" , false  ) ;
        return this.$vToastify.error(
          "Los campos deben estar completos",
          "Error"
        );
      }

      try {
        
        const response = await actualizarLateArrivalsPorBookingItinerario( form ) ;

        this.estadoButton("Actualizar" , false  ) ;
        if( !response ){
          return this.$vToastify.error(
            "Los campos deben estar completos",
            "Error"
          );
        }

        this.cargarLateArrivalsPorItinerario( form.booking_itinerary_id );

        this.$vToastify.success(
          "Late Arrival actualizado correctamente",
          "¡Realizado!"
        );
      } catch (error) {
        return this.$vToastify.error(
            "Error, al actualizar Late Arrival, recargue la página y vuelva a intentar.",
            "Error!"
          );
      }

    },
    async obtenerFilaSeleccionada(fila) {
      let data_fila = this.contenedoresItinerario[fila.id];

      let numeroContenedor = data_fila.data[0];
      if (fila.accion == "Eliminar") {

        const response = await this.$vToastify.prompt({
           body: `¿Desea eliminar el Número Contenedor ${numeroContenedor}?`,
           answers: { Sí: true, No: false },
        });

        if( response ) {
          this.contenedoresItinerario = this.contenedoresItinerario.filter( (val,index) => index != fila.id );

          this.generarBotonesAcciones();
        }
      }
    },
    async generarBotonesAcciones() {
      let me = this;

      me.accionesAux = [];
      await me.contenedoresItinerario.map((item, index) => {
        me.accionesAux.push([
          {
            icon: "fa fa-times text-danger",
            title: "Eliminar",
            id: index
          },
        ]);
      });
    },
  },
  watch: {
    visibleModalEditarLateArrival: function (_new) {
      _new && this.openModal("modal");
    },
    data: function (_new) {
      this.numeroBookingModel = _new.data[12];
      this.booking_itinerary_id = parseInt( _new.data_complementaria[4] );
      this.id_booking = _new.data[0];
      this.nroContenedorModel = "falta traer el numero de contenedor";
    },
  },
};
</script>

<style>
.modal-paleta-colores .ui-modal__container {
  width: 25% !important;
}

.success-row {
  background: #44ff6c !important;
}
.warning-row {
  background: #ffff65 !important;
}
.danger-row {
  background: #ff5f5f !important;
}
.circle {
  width: 20px;
  height: 20px;
  display: inline-block;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
  border: 1px solid #e0e0e0;
}

.estiloletra {
  font-style: italic;
  font-weight: bolder;
}
</style>
